// src/components/CustomAutocomplete.jsx
import { Box, Typography, TextField, Autocomplete } from "@mui/material";

import { Business } from "@mui/icons-material";

export default function CustomAutocomplete({ options = [], value, onChange }) {
  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Buscar y seleccionar distribuidor/empresa"
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#F9FAFB",
              fontSize: "0.8rem",
            },
          }}
        />
      )}
      sx={{ flexGrow: 1 }}
      filterOptions={(options, { inputValue }) => {
        const filtered = options.filter(
          (option) =>
            option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.id.toLowerCase().includes(inputValue.toLowerCase())
        );
        return filtered;
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <Box
            component="li"
            key={key}
            {...otherProps}
            sx={{ fontSize: "0.8rem" }}
          >
            <Business sx={{ mr: 1, fontSize: 16, color: "#6B7280" }} />
            <Box>
              <Typography
                variant="body2"
                sx={{ fontSize: "0.8rem", fontWeight: 500 }}
              >
                {option.name}
              </Typography>
              <Typography
                variant="caption"
                sx={{ fontSize: "0.7rem", color: "#6B7280" }}
              >
                ID: {option.id}
              </Typography>
            </Box>
          </Box>
        );
      }}
      noOptionsText="No se encontraron distribuidores/empresas"
      loadingText="Cargando distribuidores/empresas..."
    />
  );
}
